<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-create-custom-stocktake ref="handleCreateCustomStocktake" />
    <view-stocktake-sidebar ref="viewStocktakeSidebar" />

    <div class="flex justify-between">
      <div class="flex justify-between">
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>
      </div>
      <div class="flex justify-end">
        <vs-button
          icon="add"
          @click="onClickCreateNew"
          type="relief"
          color="primary"
          class="mr-3"
          >New stocktake</vs-button
        >
      </div>
    </div>

    <!-- table -->
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        class="mt-4"
        v-model="selected"
        pagination
        search
        max-items="8"
        :data="stocktakes"
        @selected="onClicked(selected)"
      >
        <template slot="thead">
          <vs-th sort-key="stocktakeType">Type</vs-th>
          <vs-th sort-key="status">Status</vs-th>
          <vs-th sort-key="stocktakeDeadlineDate">Deadline</vs-th>
          <vs-th sort-key="deviation">Submitted by</vs-th>
          <vs-th sort-key="stockValue">Submitted on</vs-th>
          <vs-th v-if="isRM" sort-key="devations">Deviation</vs-th>
          <vs-th>Action</vs-th>
          <!-- <vs-th>Stock status</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="
                    product-name
                    font-medium
                    truncate
                    flex flex-row
                    items-center
                  "
                >
                  <img width="40" :src="ProductIcon" />
                  <p class="ml-4">
                    {{ tr.stocktakeType }}
                  </p>
                </div>
              </vs-td>
              <vs-td>
                <div>
                  <vs-chip color="warning">{{ tr.status }}</vs-chip>
                </div>
              </vs-td>

              <vs-td>
                <div>
                  {{ tr.stocktakeDeadlineDate | date }}
                </div>
              </vs-td>

              <vs-td>
                <div>
                  {{
                    tr.committedBy ? tr.committedBy.username : "Not submitted"
                  }}
                </div>
              </vs-td>

              <vs-td>
                <div v-if="isValidDate(tr.committed)">
                  {{ tr.committed | date }}
                </div>
              </vs-td>

              <vs-td v-if="isRM">
                <div
                  v-if="
                    tr.stocktakeDeviations &&
                    tr.stocktakeDeviations.stocktakeProductDeviations.length > 0
                  "
                >
                  <vs-chip color="danger">{{
                    tr.stocktakeDeviations.stocktakeProductDeviations.length +
                    " deviation(s)"
                  }}</vs-chip>
                </div>
              </vs-td>

              <vs-td>
                <feather-icon
                  icon="RefreshCwIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  v-if="tr.isApproved"
                  @click.stop="onClickCustomBasedOn(tr)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/recount-icon.png";
import HandleCreateCustomStocktake from "./HandleCreateCustomStocktake";
import ViewStocktakeSidebar from "./ViewStocktakeSidebar";
import moment from "moment";

export default {
  components: {
    HandleCreateCustomStocktake,
    ViewStocktakeSidebar,
  },
  data() {
    return {
      selected: [],
      filterByLocationId: "",
      isLoading: true,
      ProductIcon,
      currentPage: 1,
      pageSize: 10,
    };
  },
  methods: {
    onClickCustomBasedOn(existingStockTake) {
      this.$refs.handleCreateCustomStocktake.fromExisting(existingStockTake);
    },
    async onClickCreateNew() {
      this.$refs.handleCreateCustomStocktake.newStocktake();
    },
    onClicked(selected) {
      this.$refs.viewStocktakeSidebar.showSubmitted(selected);
    },
    // Check if date is valid using moment
    isValidDate(date) {
      if (!date) return false;
      return moment(date).year() > 1;
    },
  },
  computed: {
    ...mapGetters({
      isRM: "users/isRM",
      activeVenueId: "venues/activeVenueId",
      stocktakes: "stocktakes/stocktakes",
    }),
  },

  async created() {
    this.isLoading = true;

    await this.$store.dispatch("stocktakes/getStocktakes", this.activeVenueId);

    this.isLoading = false;
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
  }
}
</style>
